function isValidEmail(email: string) {
  if (!email) return false;

  let matchResult: any = [];
  matchResult = email.match(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

  return matchResult?.length > 0;
}

function isValidLinkedin(linkedinUrl: string) {
  if (!linkedinUrl) return false;

  let matchResult: any = [];
  matchResult = linkedinUrl.match(/linkedin.com\/(in|company)\/[^*<>]{3,}$/);

  return matchResult?.length > 0;
}

export default {
  isValidEmail,
  isValidLinkedin,
};
